var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"BackMatter"}},[_c('a',{staticClass:"link",on:{"click":_vm.handleTransferPage}},[_vm._v(" 総合資格学院オフィシャルサイトはこちら "),_c('IconBlank',{staticClass:"blank"})],1),_c('a',{staticClass:"logo",on:{"click":_vm.handleTransferPage}},[_c('IconLogo02',{attrs:{"fill":"#0d3f67"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }